import { useMutation as m } from "@apollo/client";
import p from "../../graphql/mutation/sendEmailRegisterOTP.js";
import f from "../../graphql/mutation/sendEmailVerifyOTP.js";
import O from "../../graphql/mutation/sendForgotPasswordOTP.js";
import P from "../../graphql/mutation/sendSetupEmailAndPasswordOTP.js";
import * as a from "ramda";
import { useState as c, useCallback as u } from "react";
const g = a.anyPass([
  a.pathOr(!1, ["data", "sendEmailVerifyOTP"]),
  a.pathOr(!1, ["data", "sendForgotPasswordOTP"]),
  a.pathOr(!1, ["data", "sendSetUpEmailAndPasswordOTP"]),
  a.pathOr(!1, ["data", "sendEmailRegisterOTP"])
]), T = [
  f,
  O,
  P,
  p
], C = (s) => {
  const [t, { loading: o }] = m(T[s]), [r, n] = c(!1);
  return {
    mutate: u(
      async (d) => {
        const { email: i } = d, l = await t({
          variables: { email: i }
        }), e = g(l);
        return n(e), e;
      },
      [t]
    ),
    data: r,
    loading: o
  };
};
export {
  C as default,
  g as deserializeResponse
};
//# sourceMappingURL=useSendOtpCode.js.map
